import { Routes } from '@angular/router';
import { userLinkedGuard } from './shared/guards/user-linked.guard';
import { userNotLinkedGuard } from './shared/guards/user-not-linked.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/general/home/home.component').then((m) => m.HomeComponent),
    canActivate: [userLinkedGuard],
  },
  {
    path: 'user',
    children: [
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/user/profile/profile.component').then((m) => m.ProfileComponent),
        canActivate: [userLinkedGuard],
      },
      {
        path: 'link',
        loadComponent: () =>
          import('./features/user/link/link.component').then((m) => m.LinkComponent),
        canActivate: [userNotLinkedGuard],
      },
      {
        path: 'unlink',
        loadComponent: () =>
          import('./features/user/unlink/unlink.component').then((m) => m.UnlinkComponent),
        canActivate: [userLinkedGuard],
      },
    ],
  },
  {
    path: 'badge',
    children: [
      {
        path: 'test',
        loadComponent: () =>
          import('./features/badges/badge-test/badge-test.component').then(
            (m) => m.BadgeTestComponent,
          ),
        canActivate: [userLinkedGuard],
      },
      {
        path: 'manage',
        loadComponent: () =>
          import('./features/badges/manage-badge/manage-badge.component').then(
            (m) => m.ManageBadgeComponent,
          ),
        canActivate: [userLinkedGuard],
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/general/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
